<template>
  <button class="btn quiz-answer-button" @click="answerClicked" :class="getButtonState">
    <p>{{ answerLetter }}</p>
  </button>
</template>

<script>

export default {
  name: "QuizAnswerButton",
  components: {},
  emits: [ "answerClicked" ],
  props: {
    question: Object,
    answerIndex: Number,
    selected: Boolean,
    showResult: Boolean,
    isCorrect: Boolean,
  },
  watch: {},
  data()
  {
    return {}
  },
  computed: {
    answerLetter()
    {
      let returnVal = '';
      switch (this.answerIndex)
      {
        case 0:
          returnVal = 'A';
          break;
        case 1:
          returnVal = 'B';
          break;
        case 2:
          returnVal = 'C';
          break;
        case 3:
          returnVal = 'D';
          break;
      }
      return returnVal;
    },

    getButtonState()
    {
      if (this.selected)
      {
        if (this.showResult)
        {
          if (this.isCorrect)
          {
            return 'correct';
          }
          else
          {
            return 'wrong';
          }
        }
        else
        {
          return 'selected';
        }
      }
      else
      {
        return '';
      }
    }
  },
  methods: {
    answerClicked()
    {
      if (!this.showResult)
      {
        this.$emit("answerClicked", this.answerIndex);
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.quiz-answer-button {

  background-image: url("~@/assets/image/platform/button/button_quiz_01.svg");
  width: 90px;
  height: 90px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  p {
    color: white;
    font-weight: bold;
    font-size: 2rem;
    margin: 0;
  }

  &.selected {
    background-image: url("~@/assets/image/platform/button/button_quiz_02.svg");
  }

  &.correct {
    background-image: url("~@/assets/image/platform/button/button_quiz_04.svg");
  }

  &.wrong {
    background-image: url("~@/assets/image/platform/button/button_quiz_03.svg");
  }


}


</style>